import { render } from "./CaseViewer.vue?vue&type=template&id=0f0e858c&scoped=true"
import script from "./CaseViewer.vue?vue&type=script&lang=js"
export * from "./CaseViewer.vue?vue&type=script&lang=js"

import "./CaseViewer.vue?vue&type=style&index=0&id=0f0e858c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f0e858c"]])

export default __exports__